<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام باربری"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              type="text"
              name="boss_name"
              label="نام رئیس"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.boss_name"
            />
            <bita-input
              type="carrier_code"
              name="carrier_code"
              label="کد باربری"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.carrier_code"
            />
            <bita-input
              type="postal_code"
              name="postal_code"
              label="کد پستی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.postal_code"
            />
            <bita-input
              type="text"
              name="phone"
              label="شماره تماس"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
            />
            <bita-select
              name="province"
              label="استان"
              ref="provinceDropDown"
              rules="required"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="province"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.state_id"
              @change="(e) => this.getCity(e)"
            />
            <bita-spinner
              :is-loading="isLoadingCities"
              class-name="col-lg-2"
              styleName="align-self: center;"
            />
            <bita-select
              v-if="this.isLoadingCities == false"
              name="citiesOrgin"
              label="شهر"
              ref="citiesDropDown"
              rules="required"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="cities"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.city_id"
            />
            <bita-textarea
              name="address"
              rules="required"
              class="col-12"
              inputClass="col-12 form-control"
              place-holder="آدرس"
              v-model="dataForm.address"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer" class="d-flex flex-column flex-md-row">
      <div class="col-12 col-md-2 mb-2 mb-md-0" v-if="!propsData.id">
        <bita-bootbutton
          type="primary"
          title="ذخیره"
          class="w-100"
          @click.native="handleSubmit()"
        />
      </div>
      <div class="col-12 col-md-2" v-if="propsData.id">
        <bita-bootbutton
          type="primary"
          title="بروزرسانی"
          class="w-100"
          @click.native="handleUpdate()"
        />
      </div>
      <div class="col-12 col-md-2 mr-0 mr-md-5">
        <bita-bootbutton
          class="w-100 border-0 bg-transparent text-danger"
          type="danger"
          title="بستن"
          data-dismiss="modal"
          @click.native="
            () => {
              $emit('change-status-modal');
            }
          "
        />
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        family: "",
        national_code: "",
        phone: "",
        address: "",
        password: "",
        boss_name: "",
        carrier_code: "",
        city_id: "",
        state_id: "",
      },
    },
    propsState: {},
    propsCity: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {},
      isLoadingCities: false,
      province: [],
      cities: [],
      city_id: 0,
    };
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
    propsState: function(_data) {
      this.province = _data;
    },
    propsCity: function(_data) {
      this.cities = _data;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    handleUpdate() {
      this.$emit("on-submit", this.dataForm);
    },
    reset() {
      this.$refs.form.reset();
      this.dataForm = {};
    },
    onCloseModal(e) {
      this.reset();
    },
    getCity(e) {
      this.isLoadingCities = true;
      this.$persistClient("get", `cities?filter[province]=${e}`)
        .then((res) => {
          this.cities = res.data;
        })
        .finally((res) => {
          this.isLoadingCities = false;
        });
    },
  },
};
</script>
